import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'

export default class extends Controller {
  static targets = [
    'select',
    'quantity',
    'tipPercentage',
    'customTipInput',
    'customTipAmount',
  ]
  static values = { url: String, scheduleId: String }

  // The visible selects are nameless and belong to a decoy form so Chrome's
  // profile autofill can't touch them; the hidden quantity fields carry the
  // submitted ticket_quantities[] values and must mirror the selects.
  syncQuantities() {
    this.selectTargets.forEach((select) => {
      const hidden = this.quantityTargets.find(
        (input) => input.dataset.ticketId === select.dataset.ticketId
      )
      if (hidden) hidden.value = select.value
    })
  }

  submitOrder() {
    this.syncQuantities()

    const formData = new FormData()

    this.quantityTargets.forEach((input) => {
      formData.append(input.name, input.value)
    })

    if (this.hasTipPercentageTarget) {
      const checkedTip = this.tipPercentageTargets.find(
        (input) => input.checked
      )
      if (checkedTip) {
        formData.append(checkedTip.name, checkedTip.value)
        if (checkedTip.value === 'custom' && this.hasCustomTipAmountTarget) {
          formData.append(
            'reservation[tip_amount]',
            this.customTipAmountTarget.value
          )
        } else {
          this.customTipAmountTarget.value = 0
        }
      }
    }

    if (this.scheduleIdValue) {
      formData.append('schedule_id', this.scheduleIdValue)
    }

    // Get CSRF token from meta tag
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    // Make POST request to the order endpoint
    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': csrfToken,
        Accept: 'text/vnd.turbo-stream.html',
      },
      body: formData,
    })
      .then((response) => response.text())
      .then((html) => {
        // Process the Turbo Stream response to update the order frame
        Turbo.renderStreamMessage(html)
      })
      .catch((error) => {
        console.error('Error updating order:', error)
      })
  }

  submitOrderDebounced() {
    clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => this.submitOrder(), 300)
  }

  toggleCustomTipInput() {
    if (!this.hasCustomTipInputTarget) return
    const customRadio = this.tipPercentageTargets.find(
      (input) => input.value === 'custom'
    )
    const isCustom = customRadio && customRadio.checked
    this.customTipInputTarget.classList.toggle('d-none', !isCustom)
    if (isCustom && this.hasCustomTipAmountTarget) {
      this.customTipAmountTarget.focus()
    }
  }
}
